'use client'

import type { CardType } from './types'

import { Container, Row } from 'react-bootstrap'

import HeroImagePlatimun from '@/assets/images/credit-card-visa-platinum-hero.webp'
import HeroImage_Signature from '@/assets/images/visa-signature-credit-card-hero.webp'

function CreditCardLanding({ cardType }: { cardType: CardType }) {
  return (
    <div className="hero-container" id="credit-card-landing">
      <Container fluid className="container text-center">
        <Row className="">
          <div className="text-center mh-100 image-container">
            <img
              src={cardType === 'platinum' ? HeroImagePlatimun.src : HeroImage_Signature.src}
              alt="Hero Image"
              style={{
                display: 'block',
                width: '100%',
                height: 'auto',
                objectFit: 'contain'
              }}
            />
          </div>
        </Row>
        <Row>
          <h1 className="heading-48">
            Introducing the new alrajhi bank Malaysia
            <br /> Visa Platinum & Visa Signature{' '}
            <span className="no-wrap">
              Credit Card-<em>i</em>
            </span>
          </h1>
        </Row>
        <Row>
          <h3 className="">Discover rewards for every moment.</h3>
        </Row>
      </Container>
    </div>
  )
}

export default CreditCardLanding
